// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-PC":"solarpanel_60w_solar-60w-PC__bF82I"};